<template>
  <div>
    <el-header :class="{ 'unex-header': true }" :height="'5rem'">
      <slot></slot>
    </el-header>
  </div>
</template>

<script>
export default {
  props: ["height"],
  computed:{
    fromSP2(){
      return !!window.localStorage.getItem('fromNew')|| !!~window.location.search.indexOf("fromNew=1")
    }
  }
};
</script>
